import { InjectionToken } from '@angular/core';

export const CAPTURUM_BUILDERS_CONFIG_LIST_URL = new InjectionToken<Record<string, string>>('Capturum builder config list URL');
